import SocialButton from "./SocialButton";

const handleSocialLogin = (user) => {
  console.log(user);
};

const handleSocialLoginFailure = (err) => {
  console.error(err);
};

const InstagramLogin = () => {
  return (
    <div className="instagram-btn login-btn d-sm-inline-block">
      <SocialButton
        provider="instagram"
        appId="YOUR_APP_ID"
        onLoginSuccess={handleSocialLogin}
        onLoginFailure={handleSocialLoginFailure}
      >
        Login with Instagram
      </SocialButton>
    </div>
  )
}

export default InstagramLogin;
